import myAxios from "@/utils/request";
export default {
  // 角色管理
  getRoleList(params) {
    return myAxios.post("/api/adminrole/getadminrolebyselect", params);
  },
  batchRoleDelete(params) {
    return myAxios.post("/api/adminrole/batchdelete", params);
  },
  addRole(params) {
    return myAxios.post("/api/adminrole/addormodify", params);
  },
  getRoleInfo(params) {
    const { id } = params;
    return myAxios.get("/api/adminrole/getadminrolebyid?id=" + id);
  },
  getAuthEnumerate() {
    return myAxios.get("/api/adminrole/getfunctionlist");
  },

  // 账号管理
  getAccountList(params) {
    return myAxios.post("/api/adminuser/backpaginguser", params);
  },
  batchAccountDelete(params) {
    return myAxios.post("/api/adminuser/batchdelete", params);
  },
  addAccount(params) {
    return myAxios.post("/api/adminuser/addorupdate", params);
  },
  modAccountPWD(params) {
    return myAxios.post("/api/adminuser/updateadminpwd", params);
  },
  getAccountInfo(params) {
    const { id } = params;
    return myAxios.get("/api/adminuser/getinfo?id=" + id);
  },
  getRoleEnumerate() {
    return myAxios.get("/api/adminrole/getroleidname");
  },

  // 部门管理
  getDepartmentList(params) {
    return myAxios.post("/api/department/getdepartmentbyselect", params);
  },
  batchDepartmentDelete(params) {
    return myAxios.post("/api/department/batchdelete", params);
  },
  addDepartment(params) {
    return myAxios.post("/api/department/addormodify", params);
  },
  getDepartmentInfo(params) {
    const { id } = params;
    return myAxios.get("/api/department/getdepartmentbyid?id=" + id);
  }
};
